/**
 * 個人情報の取扱いについて（公開）
 */
import { PublicHeader, PublicFooter } from "./LandingPage.js";

const PRIMARY = "#534AB7";

export default function PrivacyPage() {
  return (
    <div style={{ fontFamily: "system-ui, -apple-system, sans-serif", color: "#1a1a1a", background: "white" }}>
      <PublicHeader minimal />

      <section style={{ background: "linear-gradient(135deg, #534AB7 0%, #7F77DD 100%)", color: "white", padding: "60px 24px 50px", textAlign: "center" }}>
        <h1 style={{ fontSize: 36, fontWeight: 800, marginBottom: 12 }}>個人情報の取扱いについて</h1>
        <p style={{ fontSize: 15, opacity: 0.95 }}>Sign Extension for クラウドサイン</p>
      </section>

      <section style={{ padding: "60px 24px", background: "#faf9f7" }}>
        <div style={{ maxWidth: 820, margin: "0 auto", background: "white", borderRadius: 12, padding: "48px 40px", lineHeight: 2, fontSize: 14 }}>
          <p style={{ marginBottom: 24 }}>
            ナウビレッジ株式会社（以下、「当社」という）は個人情報保護方針に基づき、お客様の個人情報の取扱いに細心の注意を払っております。以下、当社における個人情報の取扱いについての考え方を記載いたします。
          </p>

          <Section title="1. 個人情報の利用目的について">
            <p>当社は、当社が提供する Sign Extension for クラウドサイン（以下、「本サービス」という）の申込、利用において取得する個人情報を、以下の目的のために利用します。</p>
            <ul style={ulStyle}>
              <li>本サービスの申込登録及びユーザー認証（Google OAuth 等の外部認証サービスを通じた認証を含みます。）のため。</li>
              <li>本サービスの提供（HubSpot アカウントからのレコード情報取得、クラウドサインを通じた電子契約の送信・ステータス同期・締結済みファイルの格納を含みます。）のため。</li>
              <li>本サービスにかかる請求、支払い及び決済処理のため。</li>
              <li>本サービスに関するお問い合わせ対応及びお知らせを行うため。</li>
              <li>本サービスにおける電子契約の送信ログ管理、ステータス自動同期及び関連する機能の提供のため。</li>
              <li>本サービスの改善、新機能の開発及び品質向上のための分析のため。</li>
              <li>当社が提供する他のサービス、キャンペーン等に関するご案内のため。</li>
            </ul>
          </Section>

          <Section title="2. 取得する個人情報の種類について">
            <p>当社は、本サービスにおいて以下の個人情報を取得します。</p>
            <ul style={ulStyle}>
              <li>ユーザーの氏名、メールアドレスその他ユーザー登録時に提供いただく情報</li>
              <li>Google OAuth を通じて取得する Google アカウント情報（氏名、メールアドレス等。なお、氏名はセッション内でのみ使用し、ログインメールアドレスのみデータベースに保存します。）</li>
              <li>本サービスの利用に伴い自動的に取得されるアクセスログ、IP アドレス、Cookie 情報、利用端末情報等</li>
              <li>ユーザーの HubSpot アカウントから本サービスに同期されるレコードの識別情報及び本サービスの機能提供に必要なレコードのプロパティ値（契約ステータス、書類 ID 等。保存範囲はユーザーの設定に応じます。）。なお、電子契約の宛先の氏名・メールアドレスはサーバーに保存せず、クラウドサインへの送信時にのみ使用します。</li>
            </ul>
            <p style={{ marginTop: 16 }}>
              なお、本サービスを通じて電子契約を送信する場合、宛先として指定された氏名・メールアドレス等の個人情報がクラウドサイン（弁護士ドットコム株式会社）のサービスに送信されます。ユーザーは、当該個人情報をクラウドサインに送信するにあたり、個人情報の保護に関する法律その他の適用法令に従い、必要な同意の取得その他の適法な措置を講じた上で行うものとします。
            </p>
          </Section>

          <Section title="3. 個人情報の安全管理措置に関して">
            <p>当社は、お客様の個人情報の紛失、破壊、改ざん、漏えい等が起こらないよう適切な安全管理措置を実施し、厳正に管理します。</p>
          </Section>

          <Section title="4. 個人情報の第三者への提供について">
            <p>当社は、あらかじめご本人の同意を得ることなく、個人情報を第三者に提供することはございません。</p>
            <p>ただし、次の場合には、あらかじめご本人の同意を得ることなく、個人情報を第三者に提供することがありますので、あらかじめご了承ください。</p>
            <ol style={olStyle}>
              <li>法令に基づく場合</li>
              <li>人の生命、身体又は財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難である場合</li>
              <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難である場合</li>
              <li>国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合</li>
            </ol>
          </Section>

          <Section title="5. 外国にある第三者への個人データの提供について">
            <p>本サービスは、以下の外国に所在する第三者が提供するサービスと連携しており、これらのサービスの利用に伴い、個人データが外国（米国）にある第三者に提供される場合があります。</p>
            <ul style={ulStyle}>
              <li>米国 HubSpot, Inc.（CRM データ連携：OAuth 情報、レコード ID 等）</li>
              <li>米国 Google LLC（認証：メールアドレス、氏名等）</li>
              <li>米国 Stripe, Inc.（決済処理：管理者メールアドレス）</li>
              <li>米国 Resend, Inc.（メール送信：受信者メールアドレス）</li>
            </ul>
            <p style={{ marginTop: 16 }}>
              米国における個人情報の保護に関する制度については、個人情報保護委員会が公表する情報をご参照ください。
            </p>
            <p>
              当社は、これらの外部サービス提供者との間で、個人データの適切な取扱いに関する契約を締結する等、個人情報の保護に関する法律に基づき必要な措置を講じます。
            </p>
          </Section>

          <Section title="6. 個人情報の取扱いの委託について">
            <p>当社は、個人情報を取り扱う業務の全部又は一部を外部に委託することがあります。</p>
            <p>この場合、当社は、個人情報保護体制が整備された委託先を選定するとともに、適切に監督します。</p>
            <p>本サービスにおいては、クラウドサインの提供者である弁護士ドットコム株式会社（日本）に対し、電子契約送信機能の提供のため、宛先個人情報の取扱いを委託しています。</p>
          </Section>

          <Section title="7. Cookie その他の技術的手段について">
            <p>
              当社は、本サービスにおいて、Cookie、ウェブビーコンその他類似の技術を使用します。これらは、ユーザー認証、セッション管理、サービスの利用状況の分析等の目的で使用されます。ユーザーは、ブラウザの設定により Cookie の受入れを拒否することができますが、その場合、本サービスの一部の機能が利用できなくなることがあります。
            </p>
          </Section>

          <Section title="8. 個人情報の開示、苦情及び相談について">
            <p>
              お客様は当社が管理しているお客様の保有個人データに対して、開示等（利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止及び第三者提供記録の開示）を求めることができます。希望される場合は、「ナウビレッジ株式会社 個人情報相談窓口」までご連絡ください。なお、お客様の個人情報に関するお問い合わせ、苦情及び相談に関しても、同窓口までご連絡ください。
            </p>
            <p>保有個人データ又は第三者提供記録の開示、利用目的の通知につきましては、手数料（1 件あたり 1,000 円以内）を頂戴しておりますので、あらかじめ御了承ください。</p>
          </Section>

          <Section title="9. 任意性について">
            <p>お客様が個人情報を当社に提供することは任意です。</p>
            <p>しかしながら、情報のご提供がない場合には、各サービスを受けられないことがあります。</p>
          </Section>

          <Section title="10. 個人情報に関するお問い合わせ先">
            <div style={{ background: "#faf9f7", borderRadius: 10, padding: "20px 24px", marginTop: 12 }}>
              <p style={{ fontWeight: 700, marginBottom: 6 }}>ナウビレッジ株式会社</p>
              <p>代表者：今村 邦之</p>
              <p>個人情報保護管理者：三宮 洋太</p>
              <p style={{ fontWeight: 600, marginTop: 16, marginBottom: 6 }}>【ご連絡先】</p>
              <p>ナウビレッジ株式会社 個人情報相談窓口</p>
              <p>住所：東京都港区赤坂二丁目10番5号 赤坂日ノ樹ビル2F</p>
              <p>
                メールアドレス：
                <a href="mailto:kanri@now-village.jp" style={{ color: PRIMARY }}>kanri@now-village.jp</a>
              </p>
            </div>
          </Section>
        </div>
      </section>

      <PublicFooter minimal />
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 36 }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12, paddingLeft: 12, borderLeft: `3px solid ${PRIMARY}`, color: "#1a1a1a" }}>
        {title}
      </h2>
      <div style={{ fontSize: 14, color: "#4a4a48" }}>
        {children}
      </div>
    </div>
  );
}

const ulStyle: React.CSSProperties = {
  paddingLeft: 24,
  margin: "8px 0",
};

const olStyle: React.CSSProperties = {
  paddingLeft: 28,
  margin: "8px 0",
};
